export const VARIANT = {
    LEGACY: 'legacy',
    V2: 'v2',
};

export const variantClass = (...variants) => variants
    .filter((v) => v && v !== VARIANT.LEGACY)
    .map((v) => `fv-v--${String(v).trim()}`)
    .join(' ');

export default variantClass;

